<template lang="pug"> 
  title-tab(:msg="$t('title.commission-report')")
    n-tap-01 
</template>
<script>
import NTap01 from './childs/P01' 
export default {
  components:{
    NTap01, 
  },  
}
</script>       